const mutations = {
  setShowHeadingsAndFilters(state, val) {
    state.flags.showHeadingsAndFilters = val;
  },
  setGoClicked(state, val) {
    state.flags.goClicked = val;
  },
  setLoadingIndicatorAllIds(state, val) {
    state.flags.loadingIndicatorAllIds = val;
  },
  setLoadingLPData(state, val) {
    state.flags.loadingLPData = val;
  },
  setLoadingQuestionData(state, val) {
    state.flags.loadingQuestionData = val;
  },
  setLoadingReportDataIds(state, val) {
    state.flags.loadingReportDataIds = val;
  },
  setIndicatorChanged(state, val) {
    state.flags.indicatorChanged = val;
  },
  setVisualizationChanged(state, val) {
    state.flags.visualizationChanged = val;
  },
  setShowFootnotes(state, val) {
    state.flags.showFootnotes = val;
  },
  setGeneratingPdf(state, val) {
    state.flags.generatingPdf = val;
  },

  setGSGo(state, obj) {
    state.GSGo.categoryId = obj.categoryId;
    state.GSGo.category = obj.category;
    state.flags.goClicked = true;
  },
  setIndicatorId(state, val) {
    state.indicatorId = val;
  },
  setLPData(state, arr) {
    state.lpData = arr;
  },
  setQuestionData(state, arr) {
    state.questionData = arr;
  },
  setTableConfigObject(state, arr) {
    state.tableConfigObject = arr;
  },
  setChartConfigObject(state, arr) {
    state.chartConfigObject = arr;
  },
  // setIndicatorId(state, val) {
  //   state.indicatorId = val;
  // },
  // setIndicatorAllIds(state, arr) {
  //   state.indicatorAllIds = arr;
  // },
  setStratFilters(state, obj) {
    state.stratFilters.indicatorId = obj.questionId;
    state.stratFilters.multistrat = obj.multistrat;
    state.stratFilters.yearId = obj.yearId;
    state.stratFilters.stratCatId1 = obj.stratCatId1;
    state.stratFilters.stratId1 = obj.stratId1;
    state.stratFilters.stratCatId2 = obj.stratCatId2;
    state.stratFilters.stratId2 = obj.stratId2;
    state.stratFilters.responseId = obj.responseId;
    state.stratFilters.dataValueTypeId = obj.dataValueTypeId;
    state.stratFilters.legendColumn = obj.legendColumn;
    state.stratFilters.legendType = obj.legendType;
  },
  setView(state, val) {
    state.view = val;
  },
  setReportDataIds(state, arr) {
    state.reportDataIds = arr;
  },
  setMapClassifierId(state, val) {
    state.mapClassifierId = val;
  },
  setMapClassifierCount(state, val) {
    state.mapClassifierCount = val;
  },
  setInteractionTypeIfEmpty(state, val) {
    if (state.interactionType === '') {
      state.interactionType = val;
    }
  },
  resetInteractionType(state) {
    state.interactionType = '';
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/LP/mutations.js